import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Headset = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="headset icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M12 0C16.4183 0 20 3.58172 20 8H22C23.1046 8 24 8.89543 24 10V14C24 15.1046 23.1046 16 22 16H18V8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8V16C6 17.2869 6.42976 18.5415 7.24707 19.4609C7.50411 19.7501 7.80555 20.0108 8.15234 20.2334C8.45312 19.5093 9.16703 19 10 19H14C15.1046 19 16 19.8954 16 21V22C16 23.1046 15.1046 24 14 24H10C9.04298 24 8.24353 23.3277 8.04688 22.4297C7.13759 22.0446 6.36874 21.4818 5.75293 20.7891C4.57024 19.4585 4 17.7131 4 16H2C0.895431 16 0 15.1046 0 14V10C0 8.89543 0.895431 8 2 8H4C4 3.58172 7.58172 0 12 0Z"
    />
  </svg>
)
